<div class="booking-layout-2" *ngIf="data?.title || data?.description || data?.buttonText || getFormFields().length > 0">
  <form class="booking-form" (submit)="onFormSubmit($event)" (click)="onFormClick($event)">
    <ng-container *ngIf="getFormFields().length > 0">
      <div class="form-row" *ngFor="let row of getFormRows(); trackBy: trackByRowIndex">
        <div class="form-group" [class.full-width]="field?.type === 'textarea'" *ngFor="let field of row; trackBy: trackByFieldId">
          <label *ngIf="!shouldHideTimeField(field)">{{ field?.label }}</label>
          
          <!-- Custom Date/Time Picker for date and datetime fields -->
          <div *ngIf="shouldUseDatePicker(field)" class="date-picker-wrapper">
            <app-custom-date-picker
              [showTime]="true"
              [ngModel]="getDateTimeValue(field)"
              (ngModelChange)="onDateTimeChange(field, $event)"
              [ngModelOptions]="{standalone: true}">
            </app-custom-date-picker>
          </div>
          
          <!-- Hide time field if it's being combined with a date field -->
          <ng-container *ngIf="!shouldHideTimeField(field)">
            <!-- Regular text/email/tel inputs -->
            <input 
              *ngIf="(field?.type === 'text' || field?.type === 'email' || field?.type === 'tel') && !shouldUseDatePicker(field)"
              [type]="field.type" 
              [name]="field.name || field.id"
              [value]="getFieldValue(field)"
              (input)="onFieldInput(field, $event)"
              class="form-input"
              (click)="$event.stopPropagation()"
              (focus)="$event.stopPropagation()">
            
            <!-- Time input (only show if not combined with date) -->
            <input 
              *ngIf="isTimeField(field) && !shouldHideTimeField(field)"
              [type]="field.type" 
              [name]="field.name || field.id"
              [value]="getFieldValue(field)"
              (input)="onFieldInput(field, $event)"
              class="form-input"
              (click)="$event.stopPropagation()"
              (focus)="$event.stopPropagation()">
            
            <!-- Select dropdown -->
            <select 
              *ngIf="field?.type === 'select'" 
              [name]="field.name || field.id"
              [value]="getFieldValue(field)"
              (change)="onFieldChange(field, $event)"
              class="form-select"
              (click)="$event.stopPropagation()"
              (focus)="$event.stopPropagation()">
              <option value="" disabled selected *ngIf="!getFieldValue(field)">{{ field.placeholder || 'Select ' + (field.label || 'option') }}</option>
              <option 
                *ngFor="let option of getSelectOptions(field); trackBy: trackByIndex" 
                [value]="option.value"
                [disabled]="option.disabled">
                {{ option.label }}
              </option>
            </select>
            
            <!-- Textarea -->
            <textarea 
              *ngIf="field?.type === 'textarea'"
              [name]="field.name || field.id"
              [value]="getFieldValue(field)"
              (input)="onFieldInput(field, $event)"
              class="form-textarea"
              (click)="$event.stopPropagation()"
              (focus)="$event.stopPropagation()">
            </textarea>
          </ng-container>
        </div>
      </div>
    </ng-container>
    
    <button type="submit" 
            *ngIf="data?.buttonText"
            class="booking-btn"
            [style.background-color]="data?.buttonBackgroundColor || primaryColor || '#FFFFFF'"
            [style.color]="data?.buttonTextColor || '#000000'"
            (click)="$event.stopPropagation()">{{ data?.buttonText }}</button>
  </form>
</div>
